import { useEffect, useState } from "react";
import { setExperimentalFlagsFromUrlParams } from "@utils/domainUtils";

export type SetCookiesFromUrlParamsStatus = "in-progress" | "completed";

export const useSetCookiesFromUrlParams = (): SetCookiesFromUrlParamsStatus => {
    const [status, setStatus] =
        useState<SetCookiesFromUrlParamsStatus>("in-progress");

    useEffect(() => {
        const urlParams = new URLSearchParams(document.location.search);
        setStatus("in-progress");
        setExperimentalFlagsFromUrlParams(urlParams);
        setStatus("completed");
    }, []);

    return status;
};
